import { FormTextInput } from '@nexelem/form-components';
import { ParameterLabel } from './ParameterLabel';
import { useCustomTranslation } from '../../../../../../hooks';

type TextParameterProps = {
  name: string;
  label: string;
  required: boolean;
  numeric?: boolean;
};

export const TextParameter = ({ name, label, required, numeric }: TextParameterProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <div className="flex items-center gap-6 min-h-8">
      <ParameterLabel label={label} required={required} />
      <FormTextInput
        className="shrink-0 max-w-68"
        enableClearButton
        name={name}
        placeholder={tWrapper('parameterValuePlaceholder')}
        showErrorMessage={false}
        size="small"
        type={numeric ? 'number' : 'text'}
      />
    </div>
  );
};
